import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'
import {ICONS, JSONToHTMLTable, Loading, Slider} from '../../../components'
import * as rest from '../../../services'
import {useDispatch} from 'react-redux'
import {showErrorToast, showSuccessToast} from '../../../state/toasts'
import RepairQuestions from '../forms/RepairQuestions/RepairQuestions'
import {PartRequestLine} from "./PartRequestLine";
import {PartRequestForm} from "./PartRequestForm";
import {PartRequest, TicketPrint} from "../../../api";
import {PartRequestService} from "../../../services";

export type PartRequestsProps={
  ticket:TicketPrint & {part_requests:Array<PartRequest>}
  onUpdate?:(res:any)=>void
}
const PartRequests = ({ ticket, onUpdate }:PartRequestsProps) => {
  const dispatch = useDispatch()
  const [templates, setTemplates] = useState<Array<any>>([])
  const [qError, setQError] = useState(null)
  const [loadingQNA, setLoadingQNA] = useState(false)
  const [canDisplayQuestions, setCanDisplayQuestions] = useState<boolean>()
  const getQuestionTrees = () => {
    setCanDisplayQuestions(true)
    const data = {
      data: {
        device: {
          id: ticket?.device?.identifier,
        },
        repairType: ticket?.device?.gsx_repair_type,
        parts: ticket?.part_requests?.
        // filter(p=>p.component_code && p.issue_code && p.reproducibility).
        map((part) => {
          return {
            componentIssue: {
              componentCode: part.component_code,
              issueCode: part.issue_code,
              reproducibility: part.reproducibility,
            },
            coverageOption: part.coverage_option,
            number: part.part_number,
            returnStatusCode: 'KBB',
          }
        }),
      },
    }
    setLoadingQNA(true)
    new rest.GSXService()
      .repair_questions(data)
      .then((response) => {
        setTemplates(response.questionDetails)
        setLoadingQNA(false)
      })
      .catch((errors: any) => {

          setQError(errors.response.data)
        setLoadingQNA(false)
        setTemplates([])

        showErrorToast("Error","Could not fetch Questioner.")
      })
  }
  const createPartRequest = (values:PartRequest) => {
    if(ticket.url){
      values.ticket = ticket.url
      new PartRequestService()
        .makePostRequest(values)
        .then((response) => {
          onUpdate && onUpdate({...ticket,part_requests:[response,...ticket.part_requests]})
          setCanDisplayQuestions(true)
          getQuestionTrees()
          dispatch(showSuccessToast('Success', 'Part Request created.'))
        })
        .catch((errors) => {
          dispatch(showErrorToast('Error', errors.response.data))
        })
    }

  }
  return (
    <>
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">Part Requests</ReactBootstrap.Col>
            <ReactBootstrap.Col className="text-end" xs="6">
              <Slider
                title={components.ICONS.PLUS}
                header={
                  <>
                    <span className="me-3">{components.ICONS.PLUS}</span>
                    <span>Add Part Requests</span>
                  </>
                }
              >
                <PartRequestForm ticket={ticket} onSubmit={createPartRequest} />
              </Slider>
               <ReactBootstrap.Button
           className="mr-1"
            variant={'dark'}
            onClick={() => getQuestionTrees()}
          >
            {ICONS.QUERY}
          </ReactBootstrap.Button>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body>
          {ticket.part_requests.length ? (
            <components.ItemList
              itemRenderer={(index, key) => {
                return (
                  <ReactBootstrap.Col key={ticket.part_requests[index].url}>
                    <PartRequestLine
                      ticket={ticket}
                      onUpdate={onUpdate}
                      onDelete={() => setCanDisplayQuestions(true)}
                      part_request={ticket.part_requests[index]}
                      onQnARequest={getQuestionTrees}
                    />
                  </ReactBootstrap.Col>
                )
              }}
              length={ticket.part_requests.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No previous part request found.
            </ReactBootstrap.Alert>
          )}
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>

       {qError &&
        <JSONToHTMLTable data={qError}/>

      }

      {canDisplayQuestions && (loadingQNA || (templates &&
        templates.length)) &&  <Slider open={canDisplayQuestions}
                                            title={<> {ICONS.QUERY} Questioner</>}  >
         <> {canDisplayQuestions && loadingQNA && <Loading />}
         {canDisplayQuestions &&
        !loadingQNA &&
        templates &&
        templates.length == 0 && <h1>No Qna Found</h1>}
       {canDisplayQuestions &&
        !loadingQNA &&
        templates &&
        templates.length && (
         <RepairQuestions
            ticket={ticket}
            templates={templates}
            onSave={(res)=>{
              setCanDisplayQuestions(false)
              onUpdate({...ticket,qna:[res,...[ticket.qna]]})
            }}
          />
        )}
       </>
        </Slider>
      }


    </>
  )
}

export default PartRequests
